<template>
	<div>
		<h1 class="page-header"><i class="fa-solid fa-house-chimney-user"></i> Szoba szerkesztése <small></small></h1>
		<div class="row">
			<div class="col-lg-6">
				<panel title="Alapadatok">
					<Loading v-if="!room"></Loading>
					<div v-else>
						<form @submit.prevent="updateRoom">
							<div class="form-group">
								<label for="numberInput" class="form-label">Szobaszám</label>
								<input type="text" class="form-control" v-model="room.number" :class="{'is-invalid':errors.number}" id="numberInput"/>
								<div class="invalid-feedback" v-if="errors.number">
									{{errors.number[0]}}
								</div>
							</div>							
							<div class="form-group">
								<label for="nameInput" class="form-label">Fantázianév</label>
								<input type="text" class="form-control" v-model="room.name" :class="{'is-invalid':errors.name}" id="nameInput"/>
								<div class="invalid-feedback" v-if="errors.name">
									{{errors.name[0]}}
								</div>
							</div>							
							<div class="form-group mt-2">
								<label for="descriptionInput" class="form-label">Leírás</label>
								
								<Editor :api-key="tinyMceApiKey"
									:init="{
										plugins: 'lists link image table code help wordcount'
									}"
									v-model="room.description" 
									:class="{'is-invalid':errors.description}" 
									id="descriptionInput" 
									/>

								<div class="invalid-feedback" v-if="errors.description">
									{{errors.description[0]}}
								</div>
							</div>
							<div class="form-group mt-2">
								<label for="amenitiesInput" class="form-label">Szolgáltatások</label>
								
								<Editor :api-key="tinyMceApiKey"
									:init="{
										plugins: 'lists link image table code help wordcount'
									}"
									v-model="room.amenities" 
									:class="{'is-invalid':errors.amenities}" 
									id="amenitiesInput" 
									/>
								<div class="invalid-feedback" v-if="errors.amenities">
									{{errors.amenities[0]}}
								</div>
							</div>
							<div slot="footer" class="text-end mt-2">
								<button class="btn btn-icon btn-lg btn-success" title="mentés" :disabled="loading">
									<i v-if="loading" class="fa-solid fa-cog fa-spin"></i>
									<i v-else class="fa-solid fa-floppy-disk"></i>
								</button>
							</div>
						</form>
					</div>
				</panel>				
			</div>
			<div class="col-lg-6">
				<panel title="Képek">
					<Loading v-if="!room"></Loading>
					<ImageUpload v-else parent_model="Room" :model_id="room.id"></ImageUpload>
				</panel>				
			</div>
		</div>
	</div>
</template>

<script>
	import ImageUpload from '../../components/ImageUpload';
	import Room from '../../apis/Room';
	import Editor from '@tinymce/tinymce-vue';
	export default {
		name:'EditRoom',
		components:{
			ImageUpload,
			Editor
		},
		data() {
			return {
				room:null,
				loading:false,
				errors:[],
				tinyMceApiKey: process.env.VUE_APP_TINY_MCE_API_KEY
			}
		},
		created() {
			Room.show(this.$route.params.id)
			.then(response => {
				this.room = response.data;
			});			
		},
		methods: {
			updateRoom(){
				this.loading = true;
				Room.update(this.$route.params.id,this.room)
				.finally(() => {
					this.loading = false;
				})
			}
		}
	};
</script>